import { atomFamily } from 'recoil';
import { EMPTY_FILTERS } from '@ubeya/shared-web/constants';
import { toFilterEntries } from '@ubeya/shared-web/utils/filters';

export const helpDeskFiltersStorageKey = (accountId, adminId) =>
  accountId && adminId ? `help-desk-filters_${accountId}_${adminId}` : null;

export const helpDeskFilters = atomFamily({
  key: 'helpDeskFilters',
  default: (storageKey) => {
    try {
      const saved = storageKey && localStorage.getItem(storageKey);
      const parsed = saved ? JSON.parse(saved) : null;

      return { basic: toFilterEntries(parsed?.basic), fields: toFilterEntries(parsed?.fields) };
    } catch (error) {
      return EMPTY_FILTERS;
    }
  }
});
